<div class="page-ticket">

    <a class="back-link" (click)="back()">
        <i class="fa-light fa-arrow-left"></i>
        Mis entradas
    </a>

    <div class="loading-container" *ngIf="loading">
        <ng-lottie class="lottie" [options]="loadingLottie" containerClass="loading-box"></ng-lottie>
    </div>

    <!-- Una entrada devuelta no se abre, así que aquí solo se llega por una
         URL a mano o por un pedido que ya no existe. -->
    <div class="empty-state" *ngIf="!loading && notFound">
        <i class="fa-light fa-ticket"></i>
        <p class="m-0 empty-title">Esta entrada no está disponible</p>
        <p class="m-0 empty-text">Puede que se haya devuelto o que el pedido ya no exista.</p>
        <button type="button" class="btn-primary" (click)="back()">Volver a mis entradas</button>
    </div>

    <div class="ticket-layout" *ngIf="!loading && !notFound && ticket" [class.pestana-evento]="pestanaMovil === 'evento'">

        <!-- ===== LA ENTRADA =====
             Con más de una entrada, asoman por debajo una o dos tarjetas: se
             ve de un vistazo que hay más detrás, sin leer "Entrada 1 de 5". -->
        <div class="pass-stack" [class.has-more]="tickets.length > 1" [class.has-many]="tickets.length > 2">
        <div class="pass" #passEl
             (animationend)="finDeFase($event)"
             (pointerdown)="empiezaArrastre($event)"
             (pointermove)="arrastra($event)"
             (pointerup)="sueltaArrastre($event)"
             (pointercancel)="sueltaArrastre($event, true)">
            <ng-container *ngTemplateOutlet="contenidoPase; context: { $implicit: ticket, indice: current }"></ng-container>
        </div>

        <!-- La entrada de debajo mientras se arrastra: la siguiente si el dedo
             va a la izquierda, la anterior si va a la derecha. -->
        <div class="pass pass-preview" *ngIf="previewIndice !== null && tickets[previewIndice]" aria-hidden="true">
            <ng-container *ngTemplateOutlet="contenidoPase; context: { $implicit: tickets[previewIndice], indice: previewIndice }"></ng-container>
        </div>
        </div>

        <!-- El contenido del pase, como plantilla: se pinta en el pase de
             verdad y, mientras se arrastra con el dedo, en la entrada que
             asoma debajo (ver `previewIndice`). Así, al apartar la de arriba
             se ve la siguiente de verdad y no una capa en blanco. Dentro,
             `ticket` es el de cada copia e `indice` su posición. -->
        <ng-template #contenidoPase let-ticket let-indice="indice">
            <div class="pass-head" #passHead>
                <!-- Con una sola entrada no hay nada entre lo que navegar: ni
                     flechas ni "Entrada 1 de 1". -->
                <div class="pass-nav" *ngIf="tickets.length > 1">
                    <p class="m-0 pass-count" *ngIf="!muchasEntradas">
                        Entrada {{ indice + 1 }} de {{ tickets.length }}
                    </p>

                    <!-- Con muchas entradas, el número se teclea. -->
                    <p class="m-0 pass-count pass-count-jump" *ngIf="muchasEntradas">
                        Entrada
                        <input type="number"
                               [min]="1"
                               [max]="tickets.length"
                               [value]="indice + 1"
                               aria-label="Ir a la entrada número"
                               (change)="irAEntrada($any($event.target).value)"
                               (keyup.enter)="irAEntrada($any($event.target).value)">
                        de {{ tickets.length }}
                    </p>
                    <button type="button"
                            aria-label="Entrada anterior"
                            [disabled]="indice === 0"
                            (click)="prev()">
                        <i class="fa-light fa-chevron-left"></i>
                    </button>
                    <button type="button"
                            aria-label="Entrada siguiente"
                            [disabled]="indice >= tickets.length - 1"
                            (click)="next()">
                        <i class="fa-light fa-chevron-right"></i>
                    </button>
                </div>
                <p class="m-0 pass-event">{{ eventTitle }}</p>
                <p class="m-0 pass-meta">
                    {{ dateShort }}<ng-container *ngIf="spaceName"> · {{ spaceName }}</ng-container>
                </p>
            </div>

            <!-- Troquel -->
            <div class="pass-perforation">
                <span class="notch left"></span>
                <span class="dashes"></span>
                <span class="notch right"></span>
            </div>

            <div class="pass-body">
                <qrcode class="pass-qr"
                        [qrdata]="ticket.localizador"
                        [allowEmptyString]="true"
                        [colorDark]="'#1E1E2B'"
                        [colorLight]="'#ffffffff'"
                        [elementType]="'canvas'"
                        [errorCorrectionLevel]="'M'"
                        [margin]="1"
                        [width]="400">
                </qrcode>

                <div class="pass-locator-row">
                    <p class="m-0 pass-locator">{{ ticket.localizador }}</p>
                    <button type="button"
                            class="btn-copy"
                            #tipCopiar="matTooltip"
                            [matTooltip]="copiado ? 'Localizador copiado' : 'Copiar al portapapeles'"
                            matTooltipClass="tooltip-citylok"
                            aria-label="Copiar el localizador al portapapeles"
                            (click)="copiarLocalizador(tipCopiar)">
                        <i class="fa-light" [ngClass]="copiado ? 'fa-check' : 'fa-copy'"></i>
                    </button>
                </div>

                <p class="m-0 pass-holder" *ngIf="ticket.nominative">
                    Entrada nominativa · {{ ticket.holderName }}
                </p>

                <div class="pass-divider"></div>

                <div class="pass-seat" *ngIf="ticket.sectionName || ticket.seat">
                    <div *ngIf="ticket.sectionName">
                        <p class="m-0 seat-label">Zona</p>
                        <p class="m-0 seat-value">{{ ticket.sectionName }}</p>
                    </div>
                    <div *ngIf="ticket.showRow && ticket.row">
                        <p class="m-0 seat-label">Fila</p>
                        <p class="m-0 seat-value">{{ ticket.row }}</p>
                    </div>
                    <div *ngIf="ticket.showSeatLabel && ticket.seat">
                        <p class="m-0 seat-label">Butaca</p>
                        <p class="m-0 seat-value">{{ ticket.seat }}</p>
                    </div>
                </div>

                <!-- Sin butaca asignada la entrada solo tiene tipo -->
                <div class="pass-seat pass-seat-single" *ngIf="!ticket.sectionName && !ticket.seat && ticket.ticketName">
                    <div>
                        <p class="m-0 seat-label">Entrada</p>
                        <p class="m-0 seat-value">{{ ticket.ticketName }}</p>
                    </div>
                </div>

                <!-- Las insignias son las oficiales de Google y Apple (SVG en
                     español, en assets/img/wallet). Sus guías de marca prohíben
                     recolorearlas, animarlas, taparlas, atenuarlas o ponerles
                     sombras: la imagen es el botón entero, sin fondo ni efectos
                     propios, y el estado de carga se indica en el texto de
                     debajo, nunca encima de la insignia.

                     Se ofrece una sola, la del wallet que le sirve al
                     dispositivo (ver `appleWalletAvailable`): la de Apple en
                     iPhone y iPad, y la de Google en todo lo demás, escritorio
                     incluido. Así no se ve nunca la pareja, que descuadra
                     porque cada marca impone su forma y no se pueden retocar.

                     Esta añade SOLO la entrada que se ve. Las de todas van en
                     la tarjeta "Wallet", fuera del pase. Como el texto de la
                     insignia no se puede tocar, lo de "solo esta" va encima. -->
                <!-- El mismo separador que hay sobre zona/fila/butaca: Wallet
                     es otra cosa que los datos de la entrada. -->
                <div class="pass-divider" *ngIf="walletAvailable"></div>

                <div class="wallet-actions" *ngIf="walletAvailable">
                    <!-- Lo que gana el usuario, no la mecánica: la insignia de
                         debajo ya dice "Añadir a … Wallet". "Esta" contrasta con
                         "tus N entradas" de la tarjeta de fuera. -->
                    <p class="wallet-alcance" *ngIf="walletVarias">
                        Lleva esta entrada en tu móvil
                    </p>
                    <ng-container *ngTemplateOutlet="insigniaWallet; context: { todas: false }"></ng-container>
                    <p class="wallet-loading" *ngIf="walletAlcance === 'una'">
                        <i class="fa-light fa-spinner fa-spin"></i>
                        Generando tu entrada…
                    </p>
                    <p class="wallet-error" *ngIf="walletError?.alcance === 'una'">{{ walletError?.texto }}</p>
                </div>
            </div>
        </ng-template>

        <!-- La insignia oficial, la del wallet del dispositivo, para una
             entrada o para todas. -->
        <ng-template #insigniaWallet let-todas="todas">
            <button type="button" class="wallet-badge" *ngIf="!appleWalletAvailable"
                    (click)="addToGoogleWallet(todas)" [disabled]="!!walletLoading"
                    [attr.aria-label]="todas ? 'Añadir tus ' + walletTicketsCount + ' entradas a Google Wallet' : 'Añadir esta entrada a Google Wallet'">
                <img src="assets/img/wallet/google-wallet-badge-es.svg" alt="Añadir a Google Wallet">
            </button>
            <button type="button" class="wallet-badge" *ngIf="appleWalletAvailable"
                    (click)="addToAppleWallet(todas)" [disabled]="!!walletLoading"
                    [attr.aria-label]="todas ? 'Añadir tus ' + walletTicketsCount + ' entradas a Cartera de Apple' : 'Añadir esta entrada a Cartera de Apple'">
                <!-- El texto de la insignia oficial en español es "Añadir a
                     Cartera de Apple", no "Apple Wallet": el alt tiene que
                     decir lo mismo. -->
                <img src="assets/img/wallet/apple-wallet-badge-es.svg" alt="Añadir a Cartera de Apple">
            </button>
        </ng-template>

        <!-- Las opciones de "Añadir al calendario": la ficha de escritorio y el
             botón de la pestaña "Evento y pedido" de móvil abren las mismas. -->
        <ng-template #opcionesCalendario>
            <div class="calendar-options" *ngIf="showCalendar">
                <ng-container *ngIf="plataforma === 'ios' && !sinSafari" [ngTemplateOutlet]="nativo"></ng-container>
                <button type="button" (click)="addToGoogleCalendar()">
                    <i class="fa-brands fa-google"></i>
                    Google Calendar
                </button>
                <button type="button" (click)="addToOutlookCalendar()">
                    <i class="fa-brands fa-microsoft"></i>
                    Outlook
                </button>
                <ng-container *ngIf="plataforma !== 'ios' || sinSafari" [ngTemplateOutlet]="nativo"></ng-container>
            </div>

            <ng-template #nativo>
                <a *ngIf="!sinSafari && icsHref" [href]="icsHref" (click)="cerrarCalendarioTrasNavegar()">
                    <i [ngClass]="plataforma === 'ios' || plataforma === 'mac' ? 'fa-brands fa-apple' : 'fa-light fa-calendar'"></i>
                    {{ nativeCalendarLabel }}
                </a>
                <!-- En iPhone, fuera de Safari, el .ics no llega al Calendario: se
                     avisa en vez de dejar un enlace que no hace nada. -->
                <p class="m-0 calendar-aviso" *ngIf="sinSafari">
                    <i class="fa-brands fa-apple"></i>
                    <span>Para el calendario del iPhone, abre esta página en Safari</span>
                </p>
            </ng-template>
        </ng-template>

        <!-- El pedido como un recibo: una línea por entrada (las devueltas,
             tachadas, porque el total también las cuenta), el total y la
             descarga. Lo usan la pestaña "Evento y pedido" de móvil y la
             columna de datos de escritorio. -->
        <ng-template #recibo>
        <section class="recibo">
            <!-- La descarga va arriba, junto al título, y no al final: así se
                 ve siempre, con el recibo plegado o desplegado. -->
            <div class="recibo-cabecera">
                <div class="recibo-cabecera-textos">
                    <p class="m-0 recibo-titulo">{{ isSeasonPassOrder ? 'Entradas de tu abono' : 'Tu pedido' }}</p>
                    <span class="recibo-pedido" *ngIf="!isSeasonPassOrder">#{{ orderNumber }} · {{ purchasedOn }}</span>
                </div>
                <button type="button" class="btn-primary recibo-descarga" *ngIf="!isSeasonPassOrder"
                        (click)="downloadTickets()" [disabled]="descargando"
                        title="Descargar en PDF todas las entradas del pedido">
                    <i class="fa-light" [ngClass]="descargando ? 'fa-spinner fa-spin' : 'fa-arrow-down-to-line'"></i>
                    <!-- Corto: dentro de "Tu pedido" ya se sabe de qué pedido son, y
                         así cabe al lado del título también en recibos estrechos. -->
                    {{ descargando ? 'Preparando…' : 'Descargar entradas' }}
                </button>
            </div>
            <div class="recibo-corte"></div>
            <!-- Desplegado, la lista tiene un alto fijo y scroll propio: con 16
                 (o 136) entradas la tarjeta se alargaba sin fin. -->
            <div class="recibo-lineas" [class.abiertas]="reciboAbierto">
                <div class="recibo-linea" *ngFor="let linea of lineasReciboVisibles" [class.devuelta]="linea.devuelta">
                    <div class="recibo-linea-texto">
                        <span>{{ linea.texto }}</span>
                        <span class="recibo-linea-tipo" *ngIf="linea.tipo || linea.devuelta">
                            {{ linea.devuelta ? 'Devuelta' : linea.tipo }}
                        </span>
                    </div>
                    <span class="recibo-linea-precio" *ngIf="!isSeasonPassOrder">{{ linea.precio | currency: 'EUR' }}</span>
                </div>
            </div>
            <button type="button" class="recibo-mas" *ngIf="lineasRecibo.length > reciboPlegadoHasta"
                    (click)="reciboAbierto = !reciboAbierto">
                {{ reciboAbierto ? 'Ver menos' : 'Ver las ' + lineasRecibo.length + ' entradas' }}
                <i class="fa-light" [ngClass]="reciboAbierto ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </button>
            <ng-container *ngIf="!isSeasonPassOrder">
                <div class="recibo-corte"></div>
                <div class="recibo-total">
                    <span>Total</span>
                    <span>{{ total | currency: 'EUR' }}</span>
                </div>
            </ng-container>
        </section>
        </ng-template>

        <!-- ===== DETALLE Y ACCIONES ===== -->
        <div class="ticket-info">

            <h1 class="event-title">{{ eventTitle }}</h1>

            <!-- Solo en móvil (ver el scss): el evento en pequeño y las dos
                 pestañas. "Entradas" lleva lo de la puerta (el montón, la
                 descarga y Wallet) y "Evento y pedido" lo demás. -->
            <div class="cabecera-movil">
                <div class="cabecera-evento">
                    <div class="cabecera-cartel" [class.empty]="!eventImage">
                        <img *ngIf="eventImage" [src]="urlEvents + eventImage" alt="" (error)="eventImage = null">
                        <i class="fa-light fa-image" *ngIf="!eventImage"></i>
                    </div>
                    <div class="cabecera-textos">
                        <p class="m-0 cabecera-titulo">{{ eventTitle }}</p>
                        <p class="m-0 cabecera-fecha">{{ dateShort }}<ng-container *ngIf="spaceName"> · {{ spaceName }}</ng-container></p>
                    </div>
                </div>
                <div class="pestanas" role="tablist" aria-label="Secciones de la entrada">
                    <button type="button" role="tab" [attr.aria-selected]="pestanaMovil === 'entradas'"
                            [class.activa]="pestanaMovil === 'entradas'" (click)="pestanaMovil = 'entradas'">
                        <span class="tab-text">
                            {{ tickets.length === 1 ? 'Entrada' : 'Entradas' }}
                            <span class="tab-count" *ngIf="tickets.length > 1">{{ tickets.length }}</span>
                        </span>
                    </button>
                    <button type="button" role="tab" [attr.aria-selected]="pestanaMovil === 'evento'"
                            [class.activa]="pestanaMovil === 'evento'" (click)="pestanaMovil = 'evento'">
                        Evento y pedido
                    </button>
                </div>
            </div>

            <!-- Solo en móvil y tablet (ver el scss): la descarga, justo debajo
                 del montón de entradas, que es lo segundo que se busca. En
                 escritorio va en la fila "Pedido" de la ficha, que ahí se ve
                 sin bajar. -->
            <div class="descarga-movil" *ngIf="!isSeasonPassOrder">
                <button type="button" class="btn-primary" (click)="downloadTickets()" [disabled]="descargando">
                    <i class="fa-light" [ngClass]="descargando ? 'fa-spinner fa-spin' : 'fa-arrow-down-to-line'"></i>
                    {{ descargando ? 'Preparando el PDF…' : 'Descargar entradas del pedido' }}
                </button>
                <p class="m-0 descarga-nota">En PDF, todas las del pedido #{{ orderNumber }}.</p>
            </div>

            <!-- Si parte del pedido está devuelto hay que decirlo: el listado
                 anuncia dos entradas y aquí se ve una sola. Va en esta columna
                 y no arriba del todo para no empujar el pase fuera de la
                 pantalla. -->
            <div class="refund-notice" *ngIf="refundedCount > 0">
                <i class="fa-light fa-arrow-rotate-left"></i>
                <p class="m-0">{{ refundNotice }}</p>
            </div>

            <section class="info-card">

                <!-- El cartel, a la izquierda de los datos y dentro de la
                     tarjeta. Entero y en su proporción, nunca recortado: los
                     carteles son verticales y cortarlos les quita justo lo que
                     importa. Sin imagen se queda el hueco con el marcador del
                     listado; en producción el cartel es obligatorio. -->
                <div class="event-poster" [class.empty]="!eventImage">
                    <img *ngIf="eventImage" [src]="urlEvents + eventImage" [alt]="eventTitle" (error)="eventImage = null">
                    <i class="fa-light fa-image" *ngIf="!eventImage"></i>
                </div>

                <div class="info-rows">

                <div class="info-line">
                    <span class="info-icon"><i class="fa-light fa-calendar"></i></span>
                    <div class="info-body">
                        <p class="m-0 info-label">Cuándo</p>
                        <p class="m-0 info-value">{{ dateLong }}</p>
                    </div>
                    <!-- Google y Outlook abren su web con el evento relleno; el
                         .ics lo sirve la API y en iPhone va el primero, porque
                         abre la hoja nativa (ver calendar-links.util). -->
                    <div class="calendar-menu">
                        <button type="button" class="info-action" (click)="toggleCalendar()" [attr.aria-expanded]="showCalendar">
                            <i class="fa-light fa-calendar-plus"></i>
                            Añadir al calendario
                        </button>

                        <ng-container *ngTemplateOutlet="opcionesCalendario"></ng-container>
                    </div>
                </div>

                <div class="info-divider" *ngIf="spaceName || address"></div>

                <div class="info-line" *ngIf="spaceName || address">
                    <span class="info-icon"><i class="fa-light fa-location-dot"></i></span>
                    <div class="info-body">
                        <p class="m-0 info-label">Dónde</p>
                        <p class="m-0 info-value">{{ spaceName || address }}</p>
                        <p class="m-0 info-extra info-extra-oneline" *ngIf="spaceName && address" [title]="address">{{ address }}</p>
                    </div>
                    <button type="button" class="info-action" (click)="openMaps()">
                        <i class="fa-light fa-location-arrow"></i>
                        Cómo llegar
                    </button>
                </div>

                </div>
            </section>

            <!-- La pestaña "Evento y pedido" de móvil (ver el scss): una ficha
                 con el cartel, la fecha y el lugar, sus dos acciones, y el pedido
                 como un recibo con una línea por entrada. En escritorio no se
                 ve: ahí está la ficha de siempre. -->
            <div class="evento-movil">
                <div class="evento-ficha">
                    <div class="evento-ficha-cartel" [class.empty]="!eventImage">
                        <img *ngIf="eventImage" [src]="urlEvents + eventImage" [alt]="eventTitle" (error)="eventImage = null">
                        <i class="fa-light fa-image" *ngIf="!eventImage"></i>
                    </div>
                    <div class="evento-ficha-datos">
                        <div class="evento-dato">
                            <i class="fa-light fa-calendar"></i>
                            <p class="m-0">{{ dateLong }}</p>
                        </div>
                        <div class="evento-dato" *ngIf="spaceName || address">
                            <i class="fa-light fa-location-dot"></i>
                            <div>
                                <p class="m-0">{{ spaceName || address }}</p>
                                <p class="m-0 evento-dato-extra" *ngIf="spaceName && address">{{ address }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="evento-acciones">
                    <div class="calendar-menu">
                        <button type="button" class="evento-boton" (click)="toggleCalendar()" [attr.aria-expanded]="showCalendar">
                            <i class="fa-light fa-calendar-plus"></i>
                            Calendario
                        </button>
                        <ng-container *ngTemplateOutlet="opcionesCalendario"></ng-container>
                    </div>
                    <button type="button" class="evento-boton" *ngIf="spaceName || address" (click)="openMaps()">
                        <i class="fa-light fa-location-arrow"></i>
                        Cómo llegar
                    </button>
                </div>

                <ng-container *ngTemplateOutlet="recibo"></ng-container>
            </div>

            <!-- El pedido como recibo y, al lado, Wallet de todas. En móvil esta
                 caja no existe (display: contents): el recibo va en la pestaña
                 "Evento y pedido" y Wallet bajo el montón de entradas. -->
            <div class="pedido-y-wallet" [class.sin-wallet]="!walletVarias">
                <div class="recibo-escritorio">
                    <ng-container *ngTemplateOutlet="recibo"></ng-container>
                </div>

                <!-- Todas las entradas del evento al Wallet de una vez. Solo con
                     más de una: con una, la insignia del pase ya es eso. Un pase
                     por entrada, como hace todo el mundo: en la puerta se escanea
                     un QR por persona, y Wallet los apila (el back los agrupa por
                     pedido, evento y sesión). Las tres entradas asomando por la
                     esquina dicen "todas" sin tener que leerlo. -->
                <section class="wallet-todas" *ngIf="walletVarias">
                    <div class="wallet-todas-dibujo" aria-hidden="true">
                        <span></span><span></span><span></span>
                    </div>
                    <div class="info-body">
                        <p class="m-0 wallet-todas-titulo">Tus {{ walletTicketsCount }} entradas, en el móvil</p>
                        <p class="m-0 wallet-todas-sub">Juntas en tu Wallet, sin buscar el correo en la puerta.</p>
                        <p class="m-0 info-extra wallet-fila-cargando" *ngIf="walletAlcance === 'todas'">
                            <i class="fa-light fa-spinner fa-spin"></i>
                            Generando tus {{ walletTicketsCount }} entradas…<ng-container *ngIf="walletTicketsCount > 20"> Con tantas puede tardar unos segundos.</ng-container>
                        </p>
                        <p class="m-0 info-extra wallet-fila-error" *ngIf="walletError?.alcance === 'todas'">{{ walletError?.texto }}</p>
                    </div>
                    <div class="info-action-wallet">
                        <ng-container *ngTemplateOutlet="insigniaWallet; context: { todas: true }"></ng-container>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
